import React, { useState } from "react";
import { Popover, Input, Button, notification, Space } from "antd";
import { EditOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import axios from "axios";
import { API_URL } from "../../../../constants/config";
import { getAuthData, getUserTenant } from "../../../../helpers/authStorage";

export const InvoicePopover = ({ oldInvoice, orderId, fetchAccordingToTab, isAdminOrders }) => {
  const [visible, setVisible] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState(oldInvoice || "");
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);
      const { accessToken } = getAuthData();
      const tenant = getUserTenant();

      // ============================================
      // USE DIFFERENT ENDPOINT BASED ON USER ROLE
      // ============================================
      const endpoint = isAdminOrders 
        ? `${API_URL}/admin/orders/${orderId}/invoice`           // Admin endpoint
        : `${API_URL}/retailers/self/orders/${orderId}/invoice`; // Retailer endpoint

      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      };

      // Only add Tenant header for admin
      if (isAdminOrders) {
        headers.Tenant = tenant;
      }

      await axios.put(endpoint, { invoiceNumber: invoiceNumber.trim() }, { headers });

      notification.success({
        message: "Success",
        description: "Invoice number updated successfully",
      });

      setVisible(false);
      
      if (fetchAccordingToTab) {
        fetchAccordingToTab();
      }
    } catch (error) {
      console.error("Error updating invoice number:", error);
      notification.error({
        message: "Error",
        description: error?.response?.data?.message || "Failed to update invoice number",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setInvoiceNumber(oldInvoice || "");
    setVisible(false);
  };

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
    if (newVisible) {
      setInvoiceNumber(oldInvoice || "");
    }
  };

  const content = (
    <div style={{ minWidth: "250px" }}>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Input
          placeholder="Enter invoice number"
          value={invoiceNumber}
          onChange={(e) => setInvoiceNumber(e.target.value)}
          onPressEnter={handleSave}
          maxLength={50}
          autoFocus
        />
        <Space>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={handleSave}
            loading={loading}
            size="small"
          >
            Save
          </Button>
          <Button
            icon={<CloseOutlined />}
            onClick={handleCancel}
            size="small"
          >
            Cancel
          </Button>
        </Space>
      </Space>
    </div>
  );

  return (
    <Popover
      content={content}
      title="Edit Invoice Number"
      trigger="click"
      visible={visible}
      onVisibleChange={handleVisibleChange}
      placement="topLeft"
    >
      <span 
        style={{ 
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          borderRadius: "4px",
          transition: "background-color 0.3s"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f0f0"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
      >
        {oldInvoice || (
          <span style={{ color: "#999", fontStyle: "italic" }}>No invoice</span>
        )}
        <EditOutlined style={{ marginLeft: "8px", color: "#1890ff" }} />
      </span>
    </Popover>
  );
};